import ShiftLeftSlice from './shiftLeft.slice';

export const { actions: shiftLeft_actions } = ShiftLeftSlice;

export default ShiftLeftSlice.reducer;
